import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GuaranteeBanner() {
  const scrollTo = (id) =>
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="py-16 md:py-20 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[2rem] border border-amber-400/25 bg-gradient-to-br from-amber-400/10 via-white/[0.02] to-transparent p-10 md:p-16"
        >
          <div className="absolute -top-16 -right-10 w-64 h-64 rounded-full bg-amber-400/10 blur-3xl pointer-events-none" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 rounded-full bg-amber-400/15 border border-amber-400/30 px-3 py-1.5 mb-6">
                <ShieldCheck className="w-4 h-4 text-amber-400" />
                <span className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-amber-300">
                  The undeniable guarantee
                </span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tight text-white leading-[1.08]">
                We work in 90-day sprints with KPIs agreed upfront. Miss them, and
                we work for free until we hit them.
              </h2>
              <p className="mt-5 text-white/60 text-lg max-w-2xl">
                No lock-in games. No vanity reports. Just accountability tied to the
                only metric that matters: new patients booked.
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Button
                onClick={() => scrollTo("#booking")}
                className="group h-12 px-7 rounded-full bg-amber-400 text-[#070B14] hover:bg-amber-300 font-medium text-base transition-colors active:scale-95"
              >
                Claim your sprint
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
